/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component,
  ViewEncapsulation,
  ViewChild,
  OnDestroy,
} from '@angular/core';
import { RoutingService } from '../../service/routing.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { FeatureFlagsService } from 'src/app/shared/services/customer-api/feature-flags.service';
import { getScoreType as resolveScoreType } from 'src/app/shared/utils/score-type-details';
import { MatLegacyTabNav as MatTabNav } from '@angular/material/legacy-tabs';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { PortfolioNameComponent } from './news-portfolio/portfolio-name/portfolio-name.component';
import { QueryNameComponent } from './news-query/query-name/query-name.component';
import { ConfigService } from 'src/app/service/config.service';
import { PortfolioImportComponent } from './news-portfolio/portfolio-import/portfolio-import.component';
import { autofolio } from './news-portfolio/preset-folio';
import { autocollection } from './news-query/query-folio/preset-collection';
import { BreakpointService } from 'src/app/shared/services/breakpoints.service';
import { Subject, of } from 'rxjs';
import { take, map, catchError, takeUntil } from 'rxjs/operators';
import { ScoreTimeSeriesService } from 'src/app/shared/services/data-api/score-time-series.service';
import { ScoreUtilsService } from 'src/app/shared/utils/score-utils.service';
import { SentimentService } from 'src/app/shared/services/data-api/sentiment.service';
import { PortfolioApiService } from 'src/app/shared/services/customer-api/portfolio-api.service';
import {
  OTHER_COLLECTION_ID,
  QueryApiService,
} from 'src/app/shared/services/customer-api/query-api.service';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-main-news',
  templateUrl: './main-news.component.html',
  styleUrls: ['./main-news.component.scss'],
})
export class MainNewsComponent implements OnDestroy {
  params: any;
  previousValue: any;
  previousUrl: any;
  portfolios: any;
  collections: any;
  /** The "Other" tab (queries in no collection); null when there are none. */
  otherTab: { uid: string; name: string; sentiment?: any } | null = null;
  scrollDistance = 0;
  tabWidth = 247;
  tabsNumber = 0;
  selectedPortfolio: any;
  screenSize$ = this.breakpointService.screenSize$;
  scoreLoading = false;
  private destroy$ = new Subject<void>();
  @ViewChild(MatTabNav) public matTabNav: MatTabNav;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public routing: RoutingService,
    public featureFlagsService: FeatureFlagsService,
    public config: ConfigService,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private breakpointService: BreakpointService,
    private scoreTimeSeriesService: ScoreTimeSeriesService,
    private scoreUtils: ScoreUtilsService,
    private sentimentService: SentimentService,
    public portfolioApi: PortfolioApiService,
    public queryApi: QueryApiService,
  ) {
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        const currentUrl = event.url.split('?')[0];
        if (currentUrl !== this.previousUrl) {
          if (this.routing.isFolio() && this.portfolios) {
            let tabIndex = 0;
            const sortedFolios = JSON.parse(JSON.stringify(this.portfolios));
            sortedFolios.sort((a, b) => {
              return a.name.localeCompare(b.name);
            });
            sortedFolios.map((portfolio, index) => {
              if (
                portfolio.uid === this.params.id ||
                portfolio.uid === this.params.portfolioId
              ) {
                tabIndex = index;
              }
            });
            this.scrollDistance = this.tabWidth * tabIndex;
            this.tabsNumber = this.portfolios.length;
          }
          if (this.routing.isQuery() && this.collections) {
            this.scrollDistance = this.tabWidth * this.collectionTabIndex();
            this.tabsNumber = this.collections.length;
          }

          if (this.matTabNav) {
            setTimeout(() => {
              this.matTabNav.scrollDistance = this.scrollDistance;
            }, 100);
          }
        }
        this.previousUrl = currentUrl;
      }
    });

    this.route.data.subscribe((fragment) => {
      return fragment;
    });

    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe((params) => {
        this.params = params;

        if (
          this.routing.isFolio() &&
          (!this.previousValue ||
            (!this.params?.news && !this.previousValue?.news))
        ) {
          this.portfolios = this.portfolioApi.portfolios;
          if (this.portfolios && this.portfolios.length > 0) {
            this.fetchPortfolioScore();
          }
        }

        if (
          this.routing.isQuery() &&
          (!this.previousValue ||
            (!this.params?.news && !this.previousValue?.news))
        ) {
          this.otherTab = this.queryApi.otherQueries.length
            ? { uid: OTHER_COLLECTION_ID, name: 'Other' }
            : null;
          if (this.queryApi.querys?.length > 0 || this.otherTab) {
            this.collections = this.queryApi.querys ?? [];
            if (this.params.groupId && this.params.groupId !== 'default') {
              this.sentimentService
                .getSentiment(
                  Object.assign({}, this.params, { collection: true }),
                  true,
                )
                .subscribe((result) => {
                  if (this.otherTab) {
                    this.otherTab = {
                      ...this.otherTab,
                      sentiment:
                        this.params.groupId === OTHER_COLLECTION_ID
                          ? result?.sentiment
                          : undefined,
                    };
                  }
                  this.collections = this.queryApi.querys.map((collection) => {
                    if (collection.uid === this.params.groupId) {
                      return Object.assign({}, collection, {
                        sentiment:
                          result !== undefined ? result.sentiment : undefined,
                      });
                    } else {
                      return Object.assign({}, collection, {
                        sentiment: {
                          count: undefined,
                          sentiment: undefined,
                          sentiment_delta: undefined,
                          volume_ration: undefined,
                        },
                      });
                    }
                  });
                });
            }
          } else {
            this.collections = [];
          }
        }

        if (this.routing.reFresh(this.params, this.previousValue, ['id'])) {
          if (this.routing.isFolio() && !this.params.type) {
            this.selectedPortfolio = this.params.id;
            if (this.portfolios.length > this.tabsNumber) {
              let tabIndex = 0;
              const sortedFolios = JSON.parse(JSON.stringify(this.portfolios));
              sortedFolios.sort((a, b) => {
                return a.name.localeCompare(b.name);
              });
              sortedFolios.map((portfolio, index) => {
                if (portfolio.uid === this.params.id) {
                  tabIndex = index;
                }
              });
              this.scrollDistance = this.tabWidth * tabIndex;
            } else if (this.portfolios.length === this.tabsNumber) {
              let tabIndex = 0;
              const sortedFolios = JSON.parse(JSON.stringify(this.portfolios));
              sortedFolios.sort((a, b) => {
                return a.name.localeCompare(b.name);
              });
              sortedFolios.map((portfolio, index) => {
                if (portfolio.uid === this.params.id) {
                  tabIndex = index;
                }
              });
              if (tabIndex === 0) {
                this.scrollDistance = 0;
              }
            } else if (this.portfolios.length < this.tabsNumber) {
              this.scrollDistance = 0;
            }
            this.tabsNumber = this.portfolios.length;
          }

          if (this.routing.isQuery()) {
            if (this.collections.length > this.tabsNumber) {
              this.scrollDistance = this.tabWidth * this.collectionTabIndex();
            } else if (this.collections.length === this.tabsNumber) {
              if (this.collectionTabIndex() === 0) {
                this.scrollDistance = 0;
              }
            } else if (this.collections.length < this.tabsNumber) {
              this.scrollDistance = 0;
            }
            this.tabsNumber = this.collections.length;
          }

          if (this.matTabNav) {
            setTimeout(() => {
              this.matTabNav.scrollDistance = this.scrollDistance;
            }, 100);
          }
        }

        const reflowParams = ['reflow'];
        if (
          this.routing.reFresh(this.params, this.previousValue, reflowParams)
        ) {
          setTimeout(() => {
            if (this.matTabNav) {
              this.matTabNav._alignInkBarToSelectedTab();
            }
          }, 500);
        }
        this.previousValue = this.params;
      });
  }

  getScoreType(id?: string): string {
    return resolveScoreType(this.featureFlagsService.scorelabSettings, id);
  }

  inTabQuery(uid) {
    this.scrollDistance = this.matTabNav.scrollDistance;
    this.router.navigate([], {
      queryParams: {
        id: uid,
        groupId: uid,
        newstype: null,
        eventsFromScanner: null,
        tabsEventsFromScanner: this.params.eventsFromScanner ? 'true' : null,
        eventid: null,
        eventype: null,
        queryid: null,
        newsfeedFromQuery: null,
      },
      queryParamsHandling: 'merge',
      relativeTo: this.route,
    });
  }

  inTabFolio(uid) {
    this.screenSize$.pipe(take(1)).subscribe((screenSize) => {
      if (!screenSize.isMobile) {
        this.scrollDistance = this.matTabNav.scrollDistance;
      }
      this.router.navigate([], {
        queryParams: {
          id: uid,
          type: null,
          portfolioId: null,
          tag: null,
          newstype: null,
          eventsFromScanner: null,
          tabsEventsFromScanner: this.params.eventsFromScanner ? 'true' : null,
          eventid: null,
          eventype: null,
          score: null,
          time: this.params.score ? null : this.params.time,
        },
        queryParamsHandling: 'merge',
      });
    });
  }

  editPortfolio(id) {
    if (id === this.portfolioApi.activePortfolio.uid) {
      this.dialog.open(PortfolioNameComponent, {
        data: {
          action: 'edit',
        },
      });
    }
  }

  /** Position of the active collection tab; "Other" is always last. */
  private collectionTabIndex(): number {
    if (this.params.groupId === OTHER_COLLECTION_ID) {
      return this.collections.length;
    }
    const sorted = [...this.collections].sort((a, b) =>
      a.name.localeCompare(b.name),
    );
    return Math.max(
      sorted.findIndex((c) => c.uid === this.params.groupId),
      0,
    );
  }

  /** On a query's chart page `queryApi.query` is that query, not the collection. */
  editCollection() {
    const collection = this.queryApi.querys?.find(
      (c) => c.uid === this.params.groupId,
    );
    if (collection) {
      this.dialog.open(QueryNameComponent, { data: collection });
    }
  }

  addPortfolio() {
    this.dialog.open(PortfolioNameComponent, {
      data: {
        action: 'new',
      },
    });
  }

  loadSamplePortfolio() {
    this.portfolioApi.setFolios(autofolio).subscribe((result) => {
      const portfolioId = JSON.parse(result).id[0];
      // this.router.navigate([], { queryParams: { folioupdate: Math.random() }, queryParamsHandling: 'merge' });
      this.router.navigate([], {
        queryParams: {
          id: portfolioId,
          update: Math.random(),
        },
        queryParamsHandling: 'merge',
      });
    });
  }

  loadSampleCollections() {
    for (let i = 0; i < autocollection.length; i++) {
      const result = autocollection[i];
      this.queryApi.addGroupQuery(result.name).subscribe((result2) => {
        const queriesArray = [];
        result.content.forEach((query) => {
          queriesArray.push(
            Object.assign({}, query, {
              groups: [result2.id],
            }),
          );
        });
        this.queryApi.addQueries(queriesArray).subscribe(() => {
          this.router.navigate([], {
            queryParams: {
              id: result2.id,
              groupId: result2.id,
              update: Math.random(),
            },
            queryParamsHandling: 'merge',
          });
        });
      });
    }
  }

  onDragOver(event) {
    event.preventDefault();
  }

  onDropSuccess(event) {
    event.preventDefault();
    this.iImport(event, 'portfolioDrop');
  }

  /**
   * Import list of isins or portfolios from files
   */
  iImport(event, type) {
    if (event === null && type === 'isinsCreate') {
      this.dialog.open(PortfolioImportComponent);
    } else if (event !== null && type === 'portfolio') {
      if (
        this.portfolioApi.portfolios &&
        event.target.files &&
        this.portfolioApi.portfolios.length + event.target.files.length >
          this.featureFlagsService.featureFlags.portfoliosLimit
      ) {
        this.snackBar.open(
          'Number of portfolios is limited to ' +
            this.featureFlagsService.featureFlags.portfoliosLimit +
            '.',
          'OK',
          { duration: 5000 },
        );
      } else {
        if (event.target.files && event.target.files[0]) {
          for (let i = 0; i < event.target.files.length; i++) {
            const reader = new FileReader();
            reader.onload = (e: any) => {
              const result = JSON.parse(e.target.result);
              if (
                result.content &&
                result.content.length >
                  this.featureFlagsService.featureFlags
                    .entitiesPerPortfoliosLimit
              ) {
                this.snackBar.open(
                  'Number of entities per portfolio is limited to ' +
                    this.featureFlagsService.featureFlags
                      .entitiesPerPortfoliosLimit +
                    '.',
                  'OK',
                  { duration: 5000 },
                );
              } else {
                this.portfolioApi.newFolio(result.name).subscribe((result2) => {
                  this.portfolioApi
                    .addEntitiesToPortfolios(result.content, [result2.id])
                    .subscribe(() => {
                      this.router.navigate([], {
                        queryParams: {
                          id: result2.id,
                          update: Math.random(),
                        },
                        queryParamsHandling: 'merge',
                      });
                    });
                });
              }
            };
            reader.readAsText(event.target.files[i]);
          }
        }
      }
    } else if (event !== null && type === 'portfolioDrop') {
      if (
        this.portfolioApi.portfolios &&
        event.dataTransfer.files &&
        this.portfolioApi.portfolios.length + event.dataTransfer.files.length >
          this.featureFlagsService.featureFlags.portfoliosLimit
      ) {
        this.snackBar.open(
          'Number of portfolios is limited to ' +
            this.featureFlagsService.featureFlags.portfoliosLimit +
            '.',
          'OK',
          { duration: 5000 },
        );
      } else {
        if (event.dataTransfer.files && event.dataTransfer.files[0]) {
          for (let i = 0; i < event.dataTransfer.files.length; i++) {
            const reader = new FileReader();
            reader.onload = (e: any) => {
              const result = JSON.parse(e.target.result);
              if (
                result.content &&
                result.content.length >
                  this.featureFlagsService.featureFlags
                    .entitiesPerPortfoliosLimit
              ) {
                this.snackBar.open(
                  'Number of entities per portfolio is limited to ' +
                    this.featureFlagsService.featureFlags
                      .entitiesPerPortfoliosLimit +
                    '.',
                  'OK',
                  { duration: 5000 },
                );
              } else {
                this.portfolioApi.newFolio(result.name).subscribe((result2) => {
                  this.portfolioApi
                    .addEntitiesToPortfolios(result.content, [result2.id])
                    .subscribe(() => {
                      this.router.navigate([], {
                        queryParams: {
                          id: result2.id,
                          update: Math.random(),
                        },
                        queryParamsHandling: 'merge',
                      });
                    });
                });
              }
            };
            reader.readAsText(event.dataTransfer.files[i]);
          }
        }
      }
    } else if (event !== null && type === 'collection') {
      if (
        this.queryApi.querys &&
        event.target.files &&
        this.queryApi.querys.length + event.target.files.length >
          this.featureFlagsService.featureFlags.collectionsLimit
      ) {
        this.snackBar.open(
          'Number of collections is limited to ' +
            this.featureFlagsService.featureFlags.collectionsLimit +
            '.',
          'OK',
          { duration: 5000 },
        );
      } else {
        if (event.target.files && event.target.files[0]) {
          for (let i = 0; i < event.target.files.length; i++) {
            const reader = new FileReader();
            reader.onload = (e: any) => {
              const result = JSON.parse(e.target.result);
              if (
                result.content &&
                result.content.length >
                  this.featureFlagsService.featureFlags
                    .queriesPerCollectionsLimit
              ) {
                this.snackBar.open(
                  'Number of queries per collection is limited to ' +
                    this.featureFlagsService.featureFlags
                      .queriesPerCollectionsLimit +
                    '.',
                  'OK',
                  { duration: 5000 },
                );
              } else {
                this.queryApi
                  .addGroupQuery(result.name)
                  .subscribe((result2) => {
                    const queriesArray = [];
                    result.content.forEach((query) => {
                      queriesArray.push(
                        Object.assign({}, query, {
                          groups: [result2.id],
                        }),
                      );
                    });
                    this.queryApi.addQueries(queriesArray).subscribe(() => {
                      this.router.navigate([], {
                        queryParams: {
                          id: result2.id,
                          groupId: result2.id,
                          update: Math.random(),
                        },
                        queryParamsHandling: 'merge',
                      });
                    });
                  });
              }
            };
            reader.readAsText(event.target.files[i]);
          }
        }
      }
    }
  }

  addCollection() {
    if (
      this.queryApi.querys &&
      this.queryApi.querys.length >=
        this.featureFlagsService.featureFlags.collectionsLimit
    ) {
      this.snackBar.open(
        'Number of collections is limited to ' +
          this.featureFlagsService.featureFlags.collectionsLimit +
          '.',
        'OK',
        { duration: 5000 },
      );
    } else {
      this.dialog.open(QueryNameComponent, {
        // data: {}
      });
    }
  }

  checkCurrentPortfolioIndex(item, allItems) {
    const currentPortfolioId = this.params.portfolioId
      ? this.params.portfolioId
      : this.params.id;
    let current;
    let previous;
    allItems.forEach((el, index) => {
      if (currentPortfolioId === el.uid) {
        current = el.uid;
        if (index > 0) {
          previous = allItems[index - 1].uid;
        }
      }
    });
    if (current === item) {
      return true;
    } else if (previous && previous === item) {
      return true;
    } else {
      return false;
    }
  }

  checkCurrentCollectionIndex(item, allItems) {
    const currentCollectionId = this.params.groupId;
    let current;
    let previous;
    allItems.forEach((el, index) => {
      if (currentCollectionId === el.uid) {
        current = el.uid;
        if (index > 0) {
          previous = allItems[index - 1].uid;
        }
      }
    });
    if (current === item) {
      return true;
    } else if (previous && previous === item) {
      return true;
    } else {
      return false;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private fetchPortfolioScore(): void {
    this.scoreLoading = true;
    const defaultScoreId =
      this.featureFlagsService.scorelabSettings.defaultScore;
    const isSentiment = defaultScoreId === 'sentiment';
    const resolvedScore = this.scoreUtils.resolveScoreType(defaultScoreId);
    const period: number = this.params.period || 7;
    const scoreType = isSentiment ? { period: period } : resolvedScore;

    const portfolioEntities = this.portfolioApi.activePortfolioContent;

    this.scoreTimeSeriesService
      .getScoreTimeSeries({
        customParams: {
          collapse_on: ['participant'],
        },
        body: {
          score_type: scoreType,
          entity: portfolioEntities,
        },
      })
      .pipe(
        map((response) => response.score_ts?.[0]?.score_ts || []),
        catchError(() => of([])),
        takeUntil(this.destroy$),
      )
      .subscribe((scoreTs) => {
        this.scoreLoading = false;

        this.portfolios = this.portfolioApi.portfolios.map((portfolio) => {
          const isSelected =
            portfolio.uid === this.params.id ||
            portfolio.uid === this.params.portfolioId;

          if (!isSelected) {
            return isSentiment
              ? { ...portfolio, sentiment: undefined }
              : { ...portfolio, score: undefined };
          }

          if (scoreTs.length === 0) {
            return isSentiment
              ? { ...portfolio, sentiment: undefined }
              : { ...portfolio, score: undefined };
          }

          if (isSentiment) {
            const current = ScoreUtilsService.getLastScore(scoreTs);
            let delta = 0;
            if (current != null && scoreTs.length >= 2) {
              for (let i = scoreTs.length - 1; i >= 1; i--) {
                if (scoreTs[i].score != null) {
                  const prev = scoreTs[i - 1]?.score;
                  if (prev != null) {
                    delta = scoreTs[i].score - prev;
                  }
                  break;
                }
              }
            }

            return {
              ...portfolio,
              sentiment: {
                sentiment: current,
                sentiment_delta: delta,
                count: undefined,
                volume_ratio: undefined,
              },
            };
          } else {
            const score = ScoreUtilsService.getLastScore(scoreTs);
            return {
              ...portfolio,
              score: score !== null ? score.toFixed(1) : undefined,
            };
          }
        });
      });
  }
}
